module.exports = __webpack_public_path__ + "img/Mb.67bd8be4.png";